__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/cf451f1/_next/";